import(/* webpackMode: "eager" */ "/vercel/path0/apps/parrot/app/[agentSlug]/loading.tsx");
